import { IResponse } from "models";

export enum ActionType {
  STRESS_SITUATION = "action/STRESS_SITUATION",
  STRESS_SITUATION_SUCCESS = "action/STRESS_SITUATION_SUCCESS",
  STRESS_SITUATION_ERROR = "action/STRESS_SITUATION_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IStressSituationResponse extends IResponse {
  result?: any;
}
